export default __webpack_public_path__ + "static/media/Xmas1.156d079b.jpg";